import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
function CrmMenu() {
    const MenuCard = ({link, title, icon, color}) => (
        <div className="col-xl-3 col-lg-4 col-md-6 mb-4">

            <Link to={link} className="menu-link">

                <div className="menu-card" style={{borderTop: `4px solid ${color}`}}>

                    <div className="menu-icon" style={{color: color}}>
                        <FontAwesomeIcon icon={icon} size="2x"/>
                    </div>

                    <p className="menu-title">{title}</p>

                </div>

            </Link>

        </div>
    );
    return (
        <section className="container-fluid mt-4">

            <h5 className="menu-section-title">CRM System</h5>

            <div className="row">

                <MenuCard link="/lead-list" title="Lead List" icon="fa-solid fa-address-book" color="#0d6efd"/>

            </div>

        </section>
    )
}
export default CrmMenu;